import Vue from 'vue';
import Vuex from 'vuex';
import { array, classMap, autoLoad, constant } from '@/utils/helper';
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  getters: {
    getMap: state => (mapName, noAutoLoad = false) => {
      const modules = [];
      for (const moduleName in state) {
        for (const moduleMapName in state[moduleName]) {
          if (moduleMapName.toLowerCase() == mapName.toLowerCase()) {
            modules.push(moduleName);
          }
        }
      }
      if (modules.length == 0) {
        console.warn('CAN NOT FIND MODULE THAT HAVE MAP <' + mapName + '>');
      }
      if (modules.length > 1) {
        console.warn('MORE THAN ONE MODULE CONTAIN SAME MAP <' + mapName + '>, NEED TO REMOVE', modules);
      }

      const module = state[modules[0]]
      const map = module[mapName];

      if (noAutoLoad) return map;

      autoLoad(map, mapName, module);

      return map;

    },
    getArray: (state, getters) => (
      mapName,
      directly = false,
      byLocation = false,
      destroyClone = true,
      sort = false,
      masterDefault = false
    ) => {
      let list = array(getters.getMap(mapName, directly));

      list = list.filter(object => {
        const isNotDeleted = !object.deletedAt || object.deletedAt == null;
        const isClone = !!object.cloneId;
        let inLocation = true;
        if (byLocation) {
          const location = getters.getManagingLocation;
          if (location) {
            if(!masterDefault || !object.masterId) {
              let property = mapName;
              if (property == 'articles') property = 'products';
              if (!location[property]
                || location[property].length == 0
                || location[property].indexOf(object.id) == -1)
                inLocation = false;
            }
          } else {
            if (!object.masterId) inLocation = false;
          }
        }
        if(mapName == 'locations') {
          const user = getters.getMap('user', true);
          if(user.subLocations.indexOf(object.id) == -1
              && user.id != 1) return false;
        }
        return isNotDeleted && inLocation && (!destroyClone || !isClone);
      });
      if (sort) {
        list = list.sort((a, b) => {
          return a.indexNumber - b.indexNumber
        });
      }
      return list;
    },
    getObject: (state, getters) => (value, mapName, property = 'id', noDeleted = false) => {
      return array(getters.getMap(mapName))
        .find(object => {
          return object[property] == value
            && (!noDeleted
              || typeof (object.deletedAt) == 'undefined'
              || !object.deletedAt);
        });
    },
    getMapFromObjectClass: (state, getters) => objectClass => {
      if (!classMap[objectClass]) {
        console.warn('PLEASE DECLARE CLASSMAP FOR <' + objectClass + '>', classMap);
      }
      return getters.getMap(classMap[objectClass]);
    },
    getObjectFromApi: (state, getters) => apiObject => {
      const map = getters.getMapFromObjectClass(apiObject.class);
      return map[apiObject.id];
    },
    getLastObject: (state, getters) => (mapName, offset = 0) => {
      let lastObjectId = null;
      let property = mapName;
      if (property == 'articles') property = 'products';
      const map = getters.getMap(mapName);
      const location = getters.getManagingLocation;

      for (const key in map) {
        let inLocation = true;
        if (location) {
          if (!location[property]
            || location[property].length == 0
            || location[property].indexOf(map[key].id) == -1)
            inLocation = false;
        } else {
          if (!map[key].masterId) inLocation = false;
        }
        if(!inLocation) continue;
        if (!lastObjectId) {
          lastObjectId = key;
          continue;
        }
        const aString = map[key].updatedDate;
        const bString = map[lastObjectId].updatedDate;
        const aId = map[key].id;
        const bId = map[lastObjectId].id;
        if (aString > bString) {
          lastObjectId = key;
        } else if (aString == bString && aId > bId) {
          lastObjectId = key;
        }
      }
      return map[lastObjectId - offset];
    },
    getCloneList: (state, getters) => map => {
      return getters.getArray(map, false, true, false).filter(object => object.cloneId);
    },
    getClone: (state, getters) => (object, map, list = null) => {
      if (!list) {
        list = getters.getArray(map, false, false, false);
      }
      return list.find(o => o.cloneId && o.cloneId == object.masterId);
    },
  },
  actions: {
    saveObject({ getters }, object) {
      if (!classMap[object.class]) {
        console.warn('PLEASE DECLARE CLASSMAP FOR <' + object.class + '>', classMap);
      } else {
        Vue.set(getters.getMap(classMap[object.class]), object.id, object);
      }
    },
    deleteObject({ getters }, object) {
      Vue.delete(getters.getMapFromObjectClass(object.class), object.id);
    }
  },
});
